import { render } from "./CCTicketComponent.vue?vue&type=template&id=aeb09a04"
import script from "./CCTicketComponent.vue?vue&type=script&lang=js"
export * from "./CCTicketComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/daniel/Documents/CETECREA/cetecrea/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__